/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Benefits_LabelInputs */

const en_candidate_profile_benefits_label = /** @type {(inputs: Candidate_Profile_Benefits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired Benefits`)
};

const de_candidate_profile_benefits_label = /** @type {(inputs: Candidate_Profile_Benefits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewünschte Benefits`)
};

/**
* | output |
* | --- |
* | "Desired Benefits" |
*
* @param {Candidate_Profile_Benefits_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_benefits_label = /** @type {((inputs?: Candidate_Profile_Benefits_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Benefits_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_benefits_label(inputs)
	return en_candidate_profile_benefits_label(inputs)
});